import config from '../config'

export const LOAD_INTERCOM = 'LOAD_INTERCOM'
export const UNLOAD_INTERCOM = 'UNLOAD_INTERCOM'
export const UPDATE_INTERCOM_PROFILE = 'UPDATE_INTERCOM_PROFILE'
export const TRACK_INTERCOM_EVENT = 'TRACK_INTERCOM_EVENT'
export const UPDATE_INTERCOM = 'UPDATE_INTERCOM'
export const SHOW_INTERCOM = 'SHOW_INTERCOM'
export const SHOW_INTERCOM_LAUNCHER = 'SHOW_INTERCOM_LAUNCHER'
export const HIDE_INTERCOM_LAUNCHER = 'HIDE_INTERCOM_LAUNCHER'

export const loadIntercom = () => (dispatch) => {
    dispatch({ type: LOAD_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('boot', {
            app_id: config.intercomAppId,
        })
    }
}

export const unloadIntercom = () => (dispatch) => {
    dispatch({ type: UNLOAD_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('shutdown')
    }
}

export const trackIntercomEvent = (data) => (dispatch) => {
    dispatch({ type: TRACK_INTERCOM_EVENT, data })

    if (typeof window.Intercom === 'function') {
        window.Intercom('trackEvent', data)
    }
}

export const updateIntercom = (intercomSettings) => (dispatch) => {
    dispatch({ type: UPDATE_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('update', intercomSettings)
    }
}

export const updateIntercomData = (data) => (dispatch) => {
    dispatch({ type: UPDATE_INTERCOM_PROFILE, data })

    if (typeof window.Intercom === 'function') {
        window.Intercom('update', data)
    }
}

export const showIntercom = () => (dispatch) => {
    dispatch({ type: SHOW_INTERCOM })

    if (typeof window.Intercom === 'function') {
        window.Intercom('show')
    }
}

export const showIntercomLauncher = () => (dispatch) => {
    dispatch(updateIntercom({ hide_default_launcher: false }))
}

export const hideIntercomLauncher = () => (dispatch) => {
    dispatch(updateIntercom({ hide_default_launcher: true }))
}
